import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
    static targets = ['box']

    connect() {
        // Use requestAnimationFrame to ensure DOM is fully rendered
        requestAnimationFrame(() => {
            this.equalizeHeights()
        })

        // Also equalize on window resize
        this.resizeHandler = this.equalizeHeights.bind(this)
        window.addEventListener('resize', this.resizeHandler)
    }

    disconnect() {
        window.removeEventListener('resize', this.resizeHandler)
    }

    findLargestBox() {
        let maxHeight = 0
        this.boxTargets.forEach((target) => {
            const height = target.offsetHeight
            if (height > maxHeight) {
                maxHeight = height
            }
        })
        return maxHeight
    }

    equalizeHeights() {
        if (this.boxTargets.length === 0) return

        // Reset heights first to get natural heights
        this.boxTargets.forEach((target) => {
            target.style.minHeight = 'auto'
        })

        // Find the tallest element
        const maxHeight = this.findLargestBox()

        // Apply the max height to all elements
        this.boxTargets.forEach((target) => {
            target.style.minHeight = `${maxHeight}px`
        })
    }
}
